import axiosInstance from "api/axios";
import { Company } from "types/company.type";

export const companyService = {
  getAll: async (): Promise<Company[]> => {
    const { data } = await axiosInstance.get("/company");
    return data;
  },
  getSubCompanies: async (companyId: number): Promise<Company[]> => {
    const { data } = await axiosInstance.get(`/company/${companyId}/sub-companies`);
    return data;
  },
  create: async (form: FormData) => {
    return axiosInstance.post("/company", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  update: async (id: number, form: FormData) => {
    return axiosInstance.put(`/company/${id}`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  delete: async (id: number) => {
    return axiosInstance.delete(`/company/${id}`);
  },
};
